import { callApi } from '@local_modules/generic/fetch.js'

//
export async function loadCurrenciesForAccount (appAccountId) {
  const apiUrl = '/currencies/view/for-account/:appAccountId'
  const data = await callApi(apiUrl, {
    appAccountId
  })
  // console.log('loadCurrenciesForAccount', data)

  return data
}
